import { PROGRESSIVE_LEASING_ESTIMATOR } from './estimator-constant';

export const buildEstimatorURL = (
  itemCost: number,
  stateCode?: string,
): string => {
  const {
    storeId,
    estimatorLink,
    payFrequency,
    approveMeName,
    approveMeSlugValue,
    requestType = 'pdp',
  } = PROGRESSIVE_LEASING_ESTIMATOR;

  const estimatorURL = estimatorLink?.linkUrl?.destinationUrl
    ? new URL(estimatorLink.linkUrl.destinationUrl.replace('#', '%23'))
    : null;

  if (!estimatorURL) {
    return 'about:blank';
  }

  estimatorURL.searchParams.append('requestType', requestType);
  if (payFrequency) {
    estimatorURL.searchParams.append('payFrequency', payFrequency);
  }
  if (storeId) {
    estimatorURL.searchParams.append('storeId', storeId);
  }
  estimatorURL.searchParams.append('itemCost', itemCost.toString());

  if (approveMeName) {
    estimatorURL.searchParams.append('approveMeName', approveMeName);
  }
  if (approveMeSlugValue) {
    estimatorURL.searchParams.append('approveMeSlugValue', approveMeSlugValue);
  }
  if (stateCode) {
    estimatorURL.searchParams.append('stateCode', stateCode);
  }

  return decodeURIComponent(estimatorURL.href);
};
